import { SelectedWikifoliosModule } from "src/components-mui/modules/selected-wikifolios/selected-wikifolios-module";
import { ISelectedWikifolioData } from "src/components-mui/modules/selected-wikifolios/selected-wikifolios-module.types";
import { chunkArrayEqually } from "src/utils/array-util";

export interface ISelectedWikifoliosProps {
    headline: string;
    selectedWikifolios: Array<ISelectedWikifolioData> | null;
}

export const SelectedWikifolios = ({ headline, selectedWikifolios }: ISelectedWikifoliosProps) => {
    if (!selectedWikifolios) {
        return null;
    }

    const wikifolioColumns = chunkArrayEqually(selectedWikifolios, 3);

    return (
        <SelectedWikifoliosModule
            colorScheme="gray"
            title={headline}
            wfCardProps={{ className: "gtm-top-wikifolios-link" }}
            wikifolioColumns={[
                {
                    wikifolios: wikifolioColumns[0],
                },
                {
                    wikifolios: wikifolioColumns[1],
                },
                {
                    wikifolios: wikifolioColumns[2],
                },
            ]}
        />
    );
};
